export const buildProfileUrl = (
  baseUrl: string,
  profilePath: string,
): string => {
  const safeBaseUrl = typeof baseUrl === 'string' ? baseUrl : '';
  const safeProfilePath = typeof profilePath === 'string' ? profilePath : '';

  const base = safeBaseUrl.endsWith('/')
    ? safeBaseUrl.slice(0, -1)
    : safeBaseUrl;
  const path = safeProfilePath.startsWith('/')
    ? safeProfilePath
    : `/${safeProfilePath}`;
  return `${base}${path}`;
};
